export const MAX_TOP_RUNNERS = 9;
export const grid = {
  6: [0, 3, 4],
  7: [0, 6],
  8: [0],
};
